export const OUT_OF_STOCK = `Sorry, product you are trying to add is out of stock`;
export const INVALID_GST = `Please enter a valid GSTIN (eg. 29XBCDE1234F2XS)`;
export const FAILED_TO_LOAD_ERROR_MESSAGE = 'Something went wrong, Please reload the page.';
export const FAILED_TO_LOAD_PRODUCT_MESSAGE =
    'The product you are trying to view seems unavailable at the moment, Please try again after some time.';

